
import { ExportarExcelUnidadesLiberacaoVistoriaService, LiberarUnidadesEmMassaVistoriaService } from "../../../Services/VistoriaEntregaChaves/LiberacaoUnidadesVistoria/LiberacaoUnidadesVistoriaServices";
import { Controller } from "../../Controller";

export async function ExportarExcelUnidadesLiberacaoVistoriaController(
    idEmpreendimento: number
) {
    return Controller(
        ExportarExcelUnidadesLiberacaoVistoriaService(idEmpreendimento)
    );
}

export async function LiberarUnidadesEmMassaVistoriaController(
    requestBody: FormData
) {
    return Controller(
        LiberarUnidadesEmMassaVistoriaService(requestBody)
    );
}